import React, { useState } from "react";
import Header from "../common/Header";
import Aside from "../common/Asside";

function Commission() {
    const [activeTab, setActiveTab] = useState("Player");
   
  return (
    <div>
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
          <div className="main-inner">
            <div className="page-content-body" style={{display: 'block'}}>
                <div className="section">
                <div className="section-head">
                    <h2 className="title">Commission</h2>
                </div>
                <div className="section-body">
                    <div id="performanceTab">
                    <ul className="section_tab">
                        <li className="section_tab-item">
                        <a className={`section_tab-link ${activeTab === "Player" ? "active" : ""}`}
                    onClick={() => setActiveTab("Player")} style={{display: 'flex'}} href="#player">
                            Player
                        </a>
                        </li>
                        <li className="section_tab-item">
                        <a className={`section_tab-link ${activeTab === "Downline" ? "active" : ""}`}
                    onClick={() => setActiveTab("Downline")} style={{display: 'flex'}} href="#downline">
                            Downline
                        </a>
                        </li>
                    </ul>
                  {activeTab === "Player" && (
                      <div className="section-body fade active" id="finance">
                      <form action="#" id="financeForm" noValidate="novalidate">
                        <div className="filter" id="financeDateFilter">
                          <button type="button" className="btn-primary btn-dropdown dropdown-toggle">Date Filter</button>
                          <div className="dropdown-menu filter-group" style={{display: 'none'}}>
                            <dl className="filter-item">
                              <dt className="filter-head" />
                              <dd>
                                <div className="form-group">
                                  <div className="btn-group">
                                    <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-04" data-end="2024-11-04">
                                      Today
                                    </button>
                                    <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-03" data-end="2024-11-03">
                                      Yesterday
                                    </button>
                                    <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-04" data-end="2024-11-04">
                                      This Week
                                    </button>
                                    <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-10-28" data-end="2024-11-03">
                                      Last Week
                                    </button>
                                    <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-01" data-end="2024-11-04">
                                      This Month
                                    </button>
                                    <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-10-01" data-end="2024-10-31">
                                      Last Month
                                    </button>
                                  </div>
                                </div>
                              </dd>
                            </dl>
                            <div className="filter-foot">
                              <button type="button" className="btn-light cancelBtn">Cancel</button>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="form-group form-column form-3-col">
                            <label className="label bold">From </label>
                            <input type="date" className="form-control valid" name="startTime" />
                          </div>
                          <div className="form-group form-column form-3-col">
                            <label className="label bold">To </label>
                            <input type="date" className="form-control valid" name="endTime"/>
                          </div>
                          <div className="form-group form-column form-3-col">
                            <label className="label bold">Currency </label>
                            <select name="currencyTypeId" className="form-control">
                              <option value={8}>BDT </option>
                            </select>
                          </div>
                        </div>
                        <div className="table-wrap">
                          <div id="financeTable_wrapper" className="dataTables_wrapper">
                            <div className="dt-buttons">
                              <button className="dt-button buttons-collection buttons-colvis" tabIndex={0} aria-controls="financeTable" type="button" aria-haspopup="true" aria-expanded="false"><span>Column visibility</span></button>
                            </div>
                            <table id="financeTable" className="table dataTable" role="grid" aria-describedby="financeTable_info">
                              <thead>
                                <tr role="row">
                                  <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="#" style={{width: '2%'}}>#</th>
                                  <th className="sorting" tabIndex={0} aria-controls="financeTable" rowSpan={1} colSpan={1} aria-label="Start Date
                                                    : activate to sort column ascending">
                                    Start Date
                                  </th>
                                  <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Currency
                                                    ">
                                    Currency
                                  </th>
                                  <th className="sorting_desc" tabIndex={0} aria-controls="financeTable" rowSpan={1} colSpan={1} aria-sort="descending" aria-label="Net Profit
                                                    : activate to sort column ascending">
                                    Net Profit
                                  </th>
                                  <th className="sorting" tabIndex={0} aria-controls="financeTable" rowSpan={1} colSpan={1} aria-label="Commission
                                                    : activate to sort column ascending">
                                    Commission
                                  </th>
                                  <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Period
                                                    ">
                                    Period
                                  </th>
                                  <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Status
                                                    ">
                                    Status
                                  </th>
                                  <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Action
                                                    ">
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tfoot>
                                <tr>
                                  <th rowSpan={1} colSpan={1} />
                                  <th rowSpan={1} colSpan={1} />
                                  <th rowSpan={1} colSpan={1}>Page Total</th>
                                  <th rowSpan={1} colSpan={1}>0.00</th>
                                  <th rowSpan={1} colSpan={1}>0.00</th>
                                  <th rowSpan={1} colSpan={1} />
                                  <th rowSpan={1} colSpan={1} />
                                  <th rowSpan={1} colSpan={1} />
                                </tr>
                              </tfoot>
                              <tbody>
                                <tr className="odd">
                                  <td valign="top" colSpan={8} className="dataTables_empty">No data available in table</td>
                                </tr>
                              </tbody>
                            </table>
                            
                           
                            <div className="dataTables_info" id="financeTable_info" role="status" aria-live="polite">Showing 0 to 0 of 0 entries</div>
                          </div>
                        </div>
                        <div className="section-foot">
                          <div className="btn-group float-right">
                            <button type="button" className="btn-addon btn-primary reload-data">
                              <span className="ic-search" />
                              <span className="text">Search</span>
                            </button>
                          </div>
                          <div className="btn-group float-right">
                            <button type="button" className="btn-addon btn-primary exportBtn">
                              <span className="ic-excel" />
                              <span className="text">Export</span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    
                  )}
                   {activeTab === "Downline" && (
                     <div className="section-body fade active" id="downLineFinance">
                     <form action="#" id="downLineFinanceForm" noValidate="novalidate">
                       <div className="filter" id="dateFilter">
                         <button type="button" className="btn-primary btn-dropdown dropdown-toggle">Date Filter</button>
                         <div className="dropdown-menu filter-group" style={{display: 'none'}}>
                           <dl className="filter-item">
                             <dt className="filter-head" />
                             <dd>
                               <div className="form-group">
                                 <div className="btn-group">
                                   <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-04" data-end="2024-11-04">
                                     Today
                                   </button>
                                   <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-03" data-end="2024-11-03">
                                     Yesterday
                                   </button>
                                   <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-04" data-end="2024-11-04">
                                     This Week
                                   </button>
                                   <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-10-28" data-end="2024-11-03">
                                     Last Week
                                   </button>
                                   <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-11-01" data-end="2024-11-04">
                                     This Month
                                   </button>
                                   <button type="button" className="btn-secondary dateFilterBtn" data-start="2024-10-01" data-end="2024-10-31">
                                     Last Month
                                   </button>
                                 </div>
                               </div>
                             </dd>
                           </dl>
                           <div className="filter-foot">
                             <button type="button" className="btn-light cancelBtn">Cancel</button>
                           </div>
                         </div>
                       </div>
                       <div className="d-flex">
                         <div className="form-group form-column form-3-col">
                           <label className="label bold">From </label>
                           <input type="date" className="form-control" name="startTime" defaultValue="2024-10-28" max="2024-11-04" />
                         </div>
                         <div className="form-group form-column form-3-col">
                           <label className="label bold">To </label>
                           <input type="date" className="form-control" name="endTime" defaultValue="2024-11-04" max="2024-11-04" />
                         </div>
                         <div className="form-group form-column form-3-col">
                           <label className="label bold">Currency </label>
                           <select name="currencyTypeId" className="form-control">
                             <option value={8}>BDT </option>
                           </select>
                         </div>
                       </div>
                       <div className="table-wrap">
                         <div id="downLineFinanceTable_wrapper" className="dataTables_wrapper">
                           <div className="dt-buttons">
                             <button className="dt-button buttons-collection buttons-colvis" tabIndex={0} aria-controls="downLineFinanceTable" type="button" aria-haspopup="true" aria-expanded="false"><span>Column visibility</span></button>
                           </div>
                           <table id="downLineFinanceTable" className="table dataTable" role="grid" aria-describedby="downLineFinanceTable_info">
                             <thead>
                               <tr role="row">
                                 <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="#" style={{width: '2%'}}>#</th>
                                 <th className="sorting" tabIndex={0} aria-controls="downLineFinanceTable" rowSpan={1} colSpan={1} aria-label="Start Date
                                                   : activate to sort column ascending">
                                   Start Date
                                 </th>
                                 <th className="sorting" tabIndex={0} aria-controls="downLineFinanceTable" rowSpan={1} colSpan={1} aria-label="Hierarchy
                                                   : activate to sort column ascending">
                                   Hierarchy
                                 </th>
                                 <th className="sorting_desc" rowSpan={1} colSpan={1} aria-label="Currency
                                                   ">
                                   Currency
                                 </th>
                                 <th className="sorting" tabIndex={0} aria-controls="downLineFinanceTable" rowSpan={1} colSpan={1} aria-label="Net Profit
                                                   : activate to sort column ascending">
                                   Net Profit
                                 </th>
                                 <th className="sorting" tabIndex={0} aria-controls="downLineFinanceTable" rowSpan={1} colSpan={1} aria-label="Percentage(%): activate to sort column ascending">Percentage(%)</th>
                                 <th className="sorting" tabIndex={0} aria-controls="downLineFinanceTable" rowSpan={1} colSpan={1} aria-label="Commission
                                                   : activate to sort column ascending">
                                   Commission
                                 </th>
                                 <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Period
                                                   ">
                                   Period
                                 </th>
                                 <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Status
                                                   ">
                                   Status
                                 </th>
                               </tr>
                             </thead>
                             <tfoot>
                               <tr>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1}>Page Total</th>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1}>0.00</th>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1}>0.00</th>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1} />
                               </tr>
                               <tr>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1}>Grand Total</th>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1}>0.00</th>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1}>0.00</th>
                                 <th rowSpan={1} colSpan={1} />
                                 <th rowSpan={1} colSpan={1} />
                               </tr>
                             </tfoot>
                             <tbody>
                               <tr className="odd">
                                 <td valign="top" colSpan={9} className="dataTables_empty">No data available in table</td>
                               </tr>
                             </tbody>
                           </table>
                           <div className="dataTables_paginate paging_simple_numbers" id="downLineFinanceTable_paginate">
                             <a className="paginate_button previous disabled" aria-controls="downLineFinanceTable" data-dt-idx={0} tabIndex={0} id="downLineFinanceTable_previous" href="#prev">Previous</a><span />
                             <a className="paginate_button next disabled" aria-controls="downLineFinanceTable" data-dt-idx={1} tabIndex={0} id="downLineFinanceTable_next" href="#next">Next</a>
                           </div>
                           <div className="dataTables_length" id="downLineFinanceTable_length">
                             <label>
                               Show
                               <select name="downLineFinanceTable_length" aria-controls="downLineFinanceTable" className>
                                 <option value={10}>10</option>
                                 <option value={25}>25</option>
                                 <option value={50}>50</option>
                                 <option value={100}>100</option>
                               </select>
                               entries
                             </label>
                           </div>
                           <div className="dataTables_info" id="downLineFinanceTable_info" role="status" aria-live="polite">Showing 0 to 0 of 0 entries</div>
                         </div>
                       </div>
                       <div className="section-foot">
                         <div className="btn-group float-right">
                           <button type="button" className="btn-addon btn-primary reload-data">
                             <span className="ic-search" />
                             <span className="text">Search</span>
                           </button>
                         </div>
                         <div className="btn-group float-right">
                           <button type="button" className="btn-addon btn-primary exportBtn">
                             <span className="ic-excel" />
                             <span className="text">Export</span>
                           </button>
                         </div>
                       </div>
                     </form>
                   </div>
                   
                   )}
                    </div>
                </div>
                </div>
                
            </div>
            </div>

            <footer className="footer">
              Copyright © 2020. All rights Reserved
            </footer>
           
            
          </div>
        </div>
      </div>
    </div>
  );
}
export default Commission;
